// =========================================================
// * Vue Material Kit - v1.2.2
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-kit
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
// * Licensed under MIT (https://github.com/creativetimofficial/vue-material-kit/blob/master/LICENSE.md)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import VueMeta from 'vue-meta'
import VueSimpleMarkdown from 'vue-simple-markdown'
import MaterialKit from "./plugins/material-kit";

Vue.config.productionTip = false;
Vue.use(MaterialKit);

// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'vue-simple-markdown/dist/vue-simple-markdown.css'

Vue.use(VueSimpleMarkdown)

Vue.use(VueMeta)

import VueFbCustomerChat from 'vue-fb-customer-chat'
 
Vue.use(VueFbCustomerChat, {
  page_id: 203097076867288, //  change 'null' to your Facebook Page ID,
  theme_color: '#182e5a', // theme color in HEX
  locale: 'en_US', // default 'en_US'
})

const NavbarStore = {
  showNavbar: false
};

Vue.mixin({
  data() {
    return {
      NavbarStore
    };
  }
});

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {  config: { id: "G-560NVX8KYE" }});

// import VueAnalytics from 'vue-analytics'

// Vue.use(VueAnalytics, {
//   id: 'UA-XXX-X'
// })

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
